import React from "react";
import "./assets/datamap.css";
import "leaflet/dist/leaflet.css";
import MarkerClusterGroup from 'react-leaflet-cluster';
import { Circle, Marker, Popup} from 'react-leaflet';
import { drawPillarConnection } from "../../Helpers/Polylines";
import { statusImages } from '../../Helpers/deviceStatusMap';
import 'leaflet-draw/dist/leaflet.draw.css';
import L from "leaflet";
import HoverMarker from "../HoverMarker/HoverMarker";
import { useDeviceManagement } from "../../hooks/useDeviceManagement";
import fopIconUrl from './assets/marker-fop.png';

const fopIcon = L.icon({
    iconUrl: fopIconUrl,
    iconSize: [38,38]
});

export const DevicesMarkerLayer = ({ markers = [], bounds, defaultIcon, handleMarkerClick, deviceType}) => {
    return (
        <MarkerClusterGroup chunkedLoading>
            {markers.map((marker) => {
                if (!bounds.contains([marker.lat, marker.lng])) return null;
                return (
                    <React.Fragment key={`marker-${marker.id || marker.lat + '-' + marker.lng}`}>
                        {deviceType === "pillarControl" && marker.payload !== "gateway" && marker.payload !== "light"}
                          <HoverMarker
                              marker={marker}
                              icon={statusImages[marker.payload] instanceof L.Icon ? statusImages[marker.payload] : defaultIcon}
                              onClick={handleMarkerClick}
                              deviceType={deviceType}
                          />
                    </React.Fragment>
                );
            })}
        </MarkerClusterGroup>
    );
};


export const ManagementMarkerLayer = ({markers = [], bounds, defaultIcon, handleMarkerClick, deviceType }) => {
  const {moveDevice} = useDeviceManagement(false);
  if (!bounds) return null;

  return (
    <>
      <MarkerClusterGroup chunkedLoading>
        {markers.flatMap((marker) => {
          if (!bounds.contains([marker.lat, marker.lng])) return null;
          if (marker.type === 'pillar' || marker.type === 'gateway' || marker.type === 'fop') return null;

          return (
            <React.Fragment key={`marker-${marker.id || marker.lat + '-' + marker.lng}`}>
              <HoverMarker
                marker={marker}
                icon={statusImages[marker.type]}
                onClick={handleMarkerClick}
                isDraggable={true}
                deviceType={deviceType}
                moveDevice={moveDevice}
              />
              {marker.type === 'gateway' && (
                <Circle
                  center={[marker.lat, marker.lng]}
                  radius={1800}
                  color="blue"
                  fillColor="lightblue"
                  fillOpacity={0.2}
                  weight={1}
                />
              )}
            </React.Fragment>
          );
        })}
      </MarkerClusterGroup>

      {markers.flatMap((marker) => {
        if (!bounds.contains([marker.lat, marker.lng])) return null;
        if (marker.type !== 'pillar' && marker.type !== 'gateway' && marker.type !== 'fop') return null;
        return (
          <React.Fragment key={`marker-special-${marker.id || marker.lat + '-' + marker.lng}`}>
            <HoverMarker
              marker={marker}
              icon={
                marker.type === 'fop'
                  ? fopIcon
                  : (statusImages[marker.type] instanceof L.Icon ? statusImages[marker.type] : defaultIcon)
              }
              onClick={handleMarkerClick}
              isDraggable={true}
              deviceType={deviceType}
              moveDevice={moveDevice}
            />
            {marker.type === 'gateway' && (
              <Circle
                center={[marker.lat, marker.lng]}
                radius={1800}
                color="blue"
                fillColor="lightblue"
                fillOpacity={0.2}
                weight={1}
              />
            )}
            {marker.type === 'pillar' && drawPillarConnection(marker)}
          </React.Fragment>
        );
      })}
    </>
  );
};

export const RadioCoverageMarkerLayer = ({markers = [], defaultIcon, handleMarkerClick, setClickedPoints, deviceType}) => {
  
  const colors = [
    "#FF0000", // red
    "#0000FF", // blue
    "#008000", // green
    "#FFA500", // orange
    "#00FFFF", // cyan
    "#556B2F", // DarkOliveGreen
    "#483D8B", // DarkSlateBlue
    "#2F4F4F", // DarkSlateGrey
    "#CD5C5C", // IndianRed
    "#87CEFA", // LightSkyBlue
    "#8B4513", // SaddleBrown
    "#FA8072", // Salmon
    "#EE82EE", // Violet
    "#008080", // Teal
    "#D2B48C", // Tan
  ]
  return markers.map((marker, index) => {
    let color = colors[index % colors.length];
    console.log("Index:", index, "Color:", color);
    return <React.Fragment key={`radiocoverage-marker-${marker.id}`}>
        <HoverMarker
            marker={marker}
            icon={statusImages["gateway"]}
            onClick={handleMarkerClick}
            deviceType={deviceType}
        />

        {[12000, 9000, 6500, 4000, 2000].map((r, i) => (
          <Circle
            key={r}
            center={[marker.lat, marker.lng]}
            radius={r}
            fillColor={color}
            fillOpacity={0.08 * (5 - i)}
            strokeColor='transparent'
            strokeOpacity={0.08}
            strokeWeight={0}
          />
        ))}
    </React.Fragment>
  });
  
};

export const DashboardMarkerLayer = ({markers = []}) => {
    return (
        markers.map((marker, idx) => (
            <Marker
                key={idx}
                position={marker[0].coordinates}
                icon={statusImages["gateway"]}
            >
                <Popup>
                    {marker[0]}
                </Popup>
            </Marker>
        ))
    )
}